// Keep these swatches identical to apps/mobile/src/theme.ts (covered by a parity test).
export const ACCENT_KEY = 'noesa.web.themeAccent.v1';
export const DEFAULT_ACCENT_COLOR = 'aqua';
export const ACCENT_PRESETS = [
  { id: 'blue', label: 'Синий', en: 'Blue', light: { brand: '#1e66f5', brandAlt: '#06b6d4' }, dark: { brand: '#60a5fa', brandAlt: '#22d3ee' } },
  { id: 'iris', label: 'Ирис', en: 'Iris', light: { brand: '#695df6', brandAlt: '#14b8a6' }, dark: { brand: '#a78bfa', brandAlt: '#5eead4' } },
  { id: 'aqua', label: 'Аква', en: 'Aqua', light: { brand: '#0891b2', brandAlt: '#22c55e' }, dark: { brand: '#67e8f9', brandAlt: '#34d399' } },
  { id: 'emerald', label: 'Зеленый', en: 'Green', light: { brand: '#059669', brandAlt: '#84cc16' }, dark: { brand: '#34d399', brandAlt: '#bef264' } },
  { id: 'mint', label: 'Мята', en: 'Mint', light: { brand: '#0f766e', brandAlt: '#38bdf8' }, dark: { brand: '#2dd4bf', brandAlt: '#7dd3fc' } },
  { id: 'amber', label: 'Янтарь', en: 'Amber', light: { brand: '#d97706', brandAlt: '#eab308' }, dark: { brand: '#fbbf24', brandAlt: '#fde047' } },
  { id: 'orange', label: 'Апельсин', en: 'Orange', light: { brand: '#ea580c', brandAlt: '#fb7185' }, dark: { brand: '#fb923c', brandAlt: '#fda4af' } },
  { id: 'rose', label: 'Розовый', en: 'Rose', light: { brand: '#e11d48', brandAlt: '#f97316' }, dark: { brand: '#fb7185', brandAlt: '#fdba74' } },
  { id: 'violet', label: 'Фиолет', en: 'Violet', light: { brand: '#7c3aed', brandAlt: '#ec4899' }, dark: { brand: '#c084fc', brandAlt: '#f0abfc' } },
  { id: 'graphite', label: 'Графит', en: 'Graphite', light: { brand: '#334155', brandAlt: '#64748b' }, dark: { brand: '#e2e8f0', brandAlt: '#94a3b8' } },
];

export const isAccentColor = value => ACCENT_PRESETS.some(item => item.id === value);
export function accentPreset(value) {
  return ACCENT_PRESETS.find(item => item.id === value) || ACCENT_PRESETS.find(item => item.id === DEFAULT_ACCENT_COLOR);
}

export function hexRgb(color) {
  return [1, 3, 5].map(start => parseInt(color.slice(start, start + 2), 16)).join(', ');
}

// Choose readable text without changing the mobile palette's actual swatches.
export function onAccent(color) {
  const channels = hexRgb(color).split(', ').map(value => {
    const channel = Number(value) / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  return (luminance + 0.05) / 0.05 > 1.05 / (luminance + 0.05) ? '#000000' : '#ffffff';
}

const channels = color => [1, 3, 5].map(start => parseInt(color.slice(start, start + 2), 16));
function mix(color, base, amount) {
  const target = channels(base);
  return '#' + channels(color).map((value, i) => Math.round(value * amount + target[i] * (1 - amount)).toString(16).padStart(2, '0')).join('');
}
function luminance(color) {
  const c = channels(color).map(value => {
    const n = value / 255;
    return n <= .04045 ? n / 12.92 : ((n + .055) / 1.055) ** 2.4;
  });
  return c[0] * .2126 + c[1] * .7152 + c[2] * .0722;
}
function contrast(a, b) {
  const x = luminance(a), y = luminance(b);
  return (Math.max(x, y) + .05) / (Math.min(x, y) + .05);
}

// Mobile-inspired tonal controls: keep the exact swatch, but deepen/lighten its
// ink until it is readable on every interaction surface. Opaque fills make the
// contrast independent of the card, glass panel or portal behind the button.
export function accentAction(color, mode) {
  const dark = mode === 'dark';
  const surface = dark ? '#0f172a' : '#ffffff';
  const bg = mix(color, surface, dark ? .14 : .10);
  const hover = mix(color, surface, dark ? .20 : .15);
  const pressed = mix(color, surface, dark ? .25 : .20);
  const endpoint = dark ? '#ffffff' : '#000000';
  let text = color;
  for (let step = 0; step <= 100; step += 1) {
    text = mix(color, endpoint, 1 - step / 100);
    if ([bg, hover, pressed].every(fill => contrast(text, fill) >= 4.8)) break;
  }
  return { bg, hover, pressed, text, border: mix(text, bg, .42) };
}
